import React from 'react'
import './about.css'
import {aboutusdata} from '../../data'
import {MdOutlineEmail} from 'react-icons/md'
import Footer from '../../components/Footer'
import ContactUs from '../../components/ContactUs'
import '../home/home.css'

const About = () => {
  return (
    <section className='about'>
      <div className='container about__container'>
        <div className='about__layoutcontainer'>
          <h1>The Team</h1>
          <div className='flexcontainer'>
            <div className='textWrapper'>
              <div className='thestory__container'>
                <div>
                  <h3>The Story</h3>
                  <p>
                    We've started as a small startup. After few years of developing our own startups, as well as helping others, we figure out, that our team is ready to solve problems for any commercial use. So here we are, 8 years later, larger, more experienced, still open minded and ready to join you in your users journey.
                  </p>
                  <div></div>
                  <div className='margintop'></div>
                </div>
              </div>
              <div className='leadership__container'>
                <div>
                  <h3>Leadership</h3>
                  <p>
                    We're an easy going, professional bunch who take great pride in our work. We're experts at our fields. Years of experience and handful network might give you a results of advanced technology.
                  </p>
                  <div></div>
                  <div className='margintop'></div>
                </div>
              </div>
            </div>
            <div className='achievementsWrapper'></div>
          </div>
          <div className='teamMember__Container'>
              {
                aboutusdata.map(({index, icon, name, title, description, email}) => {
                  return (
                    <li className='' key={index}>
                      <div className='teamMember__Member'>
                        <div className='teamMember__FlexContainer'>
                          <div className='teamMember__ImageWrapper'>
                            <div className="teamMember__avatar">
                              <img src={icon} alt={name} />
                            </div>
                          </div>
                          <div className='teamMember__Wrapper'>
                            <h5>{title}</h5>
                            <p>{name}</p>
                          </div>
                        </div>
                        <div className='teamMember__DescriptionWrapper'>
                          <p>{description}</p>
                        </div>
                        <div className='teamMember__IconWrapper'>
                        <a href={`'mailto:' + ${email}`} target="_blank"><MdOutlineEmail className='teamMember__email-icon'/></a>
                        </div>
                      </div>
                    </li>
                  )
                })
              }
          </div>
        </div>
      </div>
      <ContactUs/>
      <Footer/>
    </section>
  )
}

export default About